import { PageType } from "../../../config/page.types";
import PlaceholderView from "../../PlaceholderView";

const KnowHowApiDocumentation = () => {
	return <PlaceholderView pageType={PageType.KnowHowApiDocumentation} text="API documentation" />;
};

export default KnowHowApiDocumentation;
